Vue.component('search', () => import(/* webpackChunkName: "search" */'@components/Search'))

Vue.component('searchables-card', () => import(/* webpackChunkName: "searchables-card" */'@/Cards/SearchablesCard'))